import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../../components/Forms/FormCreator";
import Buttons from "../../../components/ui/button/Buttons";
import { useAddEditMembershipPricingMutation, useLazyGetCorporatePricingTableQuery } from "../../../app/services/GMAP/gmapPricingTableApi";
import SwalAlert from "../../../services/swalService/SwalService";
import { gmapPricingTableFormData } from "../data/CorporatePricingTableForm.Data";

function CorporatePricingTableForm(props) {
  const GmapPricingTableRef = useRef();
  const [GmapPricingTableForm, SetGmapPricingTable] = useState(gmapPricingTableFormData);
  const { success } = SwalAlert()
  const [getCorporatePricingTable, { isSuccess: isCorporatePricingTableSuccess, isFetching: isCorporatePricingTableFetching, data: corporatePricingTable}] = useLazyGetCorporatePricingTableQuery()
  const [AddEditMembershipPricing, { isSuccess: isAddEditMembershipPricingSuccess,isFetching: isAddEditMembershipPricingFetching, data: AddEditMembershipPricingData}] = useAddEditMembershipPricingMutation()

  useEffect(() => {
    getCorporatePricingTable();
  }, [])

  useEffect(() => {
    if (!isCorporatePricingTableFetching && isCorporatePricingTableSuccess && corporatePricingTable) {
      SetGmapPricingTable({ ...GmapPricingTableForm, initialState: corporatePricingTable })
    }
  }, [isCorporatePricingTableFetching, isCorporatePricingTableSuccess, corporatePricingTable]);

  useEffect(() => {
    if (!isAddEditMembershipPricingFetching && isAddEditMembershipPricingSuccess && AddEditMembershipPricingData) {
      success("Pricing updated", "Success")
      getCorporatePricingTable();
    }
  }, [isAddEditMembershipPricingFetching, isAddEditMembershipPricingSuccess, AddEditMembershipPricingData]);

  const convertStringToNumber = (obj) => {
    const convertedObj = {};
    if (!obj)
      return
    for (const [key, value] of Object.entries(obj)) {
      if (typeof value === 'string' && !isNaN(Number(value.replace(/\$|,/g, '').trim()))) {
        convertedObj[key] = Number(value.replace(/\$|,/g, '').trim());
      } else {
        convertedObj[key] = value !== undefined && value !== null ? value : 0;
      }
    }
    return convertedObj;
  };

  const handleSave = () => {
    const pricingFormData = GmapPricingTableRef.current.getFormData();
    if (!pricingFormData)
      return;
    const convertedData = convertStringToNumber(pricingFormData);
    AddEditMembershipPricing(convertedData);
  }

  return (
    <React.Fragment>
      {
        <div className="gmap-pricing-table">
          <div className="common-project-info-main">
            <div className="custom-main-grid">
              <FormCreator
                ref={GmapPricingTableRef}
                {...GmapPricingTableForm}
              />
            </div>
            <div className="row">
              <div className="col-12">
                <div className="common-custom-pagination">
                  <div className="">
                    <Buttons
                      buttonText="Back"
                      buttonTypeClassName="black-btn"
                    />
                  </div>
                  <div className="">
                    <Buttons
                      buttonText="Save"
                      buttonTypeClassName="success-btn"
                      onClick={handleSave}
                      isLoading={isAddEditMembershipPricingFetching}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </React.Fragment >
  );
}

export default CorporatePricingTableForm;
